module.exports = __webpack_public_path__ + "media/bglb.68b7173d.mp4";